// Centered boot label while JWT / current_user load. Matches the HTML splash in layouts.
// ponytail: no real remaining-time; ease toward ~92% until this unmounts.
import React, { useEffect, useState } from "react";

const wrapStyle = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "system-ui, sans-serif",
  color: "#444",
  fontSize: "1.125rem",
  textAlign: "center",
  padding: "1.5rem",
  boxSizing: "border-box",
  gap: "1.25rem",
};

const trackStyle = {
  width: 220,
  height: 4,
  background: "#ddd",
  borderRadius: 99,
  overflow: "hidden",
};

const barPct = (elapsedMs) => {
  if (elapsedMs < 12000) {
    const x = elapsedMs / 12000;
    return 92 * (1 - Math.pow(1 - x, 3));
  }
  return Math.min(98, 92 + 6 * ((elapsedMs - 12000) / 18000));
};

const BootSplash = ({ children = "LionV3 loading" }) => {
  const [pct, setPct] = useState(2);

  useEffect(() => {
    const start = Date.now();
    const id = setInterval(() => setPct(barPct(Date.now() - start)), 50);
    return () => clearInterval(id);
  }, []);

  return (
    <div style={wrapStyle}>
      <div>{children}</div>
      <div style={trackStyle}>
        <div
          role="progressbar"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(pct)}
          style={{ height: "100%", width: `${pct}%`, background: "#444", borderRadius: 99 }}
        />
      </div>
    </div>
  );
};

export default BootSplash;
